import *as dashboardTypes from "./DashboardActionTypes";

const intialState = {
    updates: [],
    loading: true,
    loaderStatus: false,
    totalNotifications: []
}

const dashboardReducer = (state = intialState, action) => {

    switch (action.type) {
        case dashboardTypes.GET_UPDATES:
            return {
                ...state,
                loading: false,
                updates: action.payload
            }

        case dashboardTypes.ADD_UPDATE:
            return {
                ...state,
                loading: false,
            }

        case dashboardTypes.SHOW_LOADER:
            return {
                ...state,
                loading: false,
                loaderStatus: !state.loaderStatus
            }

        case dashboardTypes.SHOW_MESSAGE:
            return {
                ...state,
                loading: false,
            }

        case dashboardTypes.CALL_NOTIFICATIONS:
            return {
                ...state,
                loading: false,
                totalNotifications: action.payload
            }

        default: return state

    }
}

export default dashboardReducer